import type { FaireThemeEntity } from "../../entity_types/theme";

export const luxe_gold_under_10: FaireThemeEntity = {
  token: "luxe-gold-under-10",
  type: "theme",
  name: "Luxe Gold Under $10",
  description: "Premium 18K gold-plated jewelry offering a high-end look at wholesale price points under $10.",
  teaser: "High-end gold look, wholesale under $10 -- your best margin play.",
  detail: "You consistently order low-cost, high-margin jewelry. Gold-plated accessories for a California boutique filtered for products with wholesale price lower than the $10 anchor from your most recent orders.",
  bgColor: "#D4EBD4",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_85zuvdfqvw",
    "p_ut3tbs6mrw",
    "p_ufjavmwa64",
    "p_nrg5hxcuy3",
    "p_ar6ja253qt",
    "p_ykcapkuvqq",
    "p_7aj8n8fwkr",
    "p_5gefr7p29d",
    "p_9pm84vbjg7",
    "p_s5kj5vxsjg",
    "p_mrdc3wmdh2",
    "p_zbfwgazcex",
    "p_ychfn8hrk4",
    "p_bagjhpjgk4",
    "p_s64zjtkks2",
    "p_kdz9fw5mq5",
    "p_88qwxx7dga",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
